export default __webpack_public_path__ + "static/media/cleanproVoucher3.2ba632ec.png";